import React from 'react';
import { motion } from 'framer-motion';
import { Play, ArrowRight } from 'lucide-react';

const practiceAreasData = [
  {
    title: 'Civil Litigation',
    description: 'End-to-end civil dispute representation before all courts'
  },
  {
    title: 'Criminal Law',
    description: 'Expert defense and prosecution in criminal proceedings'
  },
  {
    title: 'Writ Petitions',
    description: 'Constitutional remedies before High Courts and Supreme Court'
  },
  {
    title: 'Bail Matters',
    description: 'Swift bail applications with strong legal arguments'
  },
  {
    title: 'Matrimonial & Family',
    description: 'Sensitive and effective resolution of family disputes'
  },
  {
    title: 'FIR & Cognizance Quashing',
    description: 'Expert petitions under CrPC for case quashing'
  },
  {
    title: 'Cheque Bounce NI Act',
    description: 'Recovery proceedings under Negotiable Instruments Act'
  },
  {
    title: 'Property & Land Disputes',
    description: 'Title, possession and revenue court matters'
  },
  {
    title: 'Consumer Protection',
    description: 'Enforcement of consumer rights under Consumer Laws'
  },
  {
    title: 'Corporate & Commercial',
    description: 'Business dispute resolution and litigation'
  },
  {
    title: 'Banking & NBFC Disputes',
    description: 'Legal solutions for banking and financial matters'
  },
  {
    title: 'Arbitration & Mediation',
    description: 'Efficient alternative dispute resolution'
  },
  {
    title: 'Service Matters',
    description: 'Cases for government and private sector employees'
  },
  {
    title: 'DRT Cases',
    description: 'Debt Recovery Tribunal representation'
  },
  {
    title: 'NCLT / NCLAT',
    description: 'Insolvency and company law proceedings'
  },
  {
    title: 'PIL',
    description: 'Public Interest Litigation for societal causes'
  },
  {
    title: 'High Court & Supreme Court',
    description: 'Appellate and writ jurisdiction matters'
  },
  {
    title: 'Legal Drafting',
    description: 'Agreements, notices, petitions and documentation'
  },
  {
    title: 'Railway Claims',
    description: 'Claims and disputes against Railways'
  }
];

const PracticeAreas = () => {
  return (
    <section 
      id="practice-areas" 
      className="py-16 md:py-24"
      style={{ backgroundColor: '#2B2BFF' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Practice Areas
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {practiceAreasData.map((area, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              className="bg-white rounded border shadow-sm p-6 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer group"
              style={{ borderColor: '#E0E0E0' }}
            >
              <div className="flex flex-col h-full">
                <div className="mb-4">
                  <Play 
                    className="h-8 w-8 transition-colors" 
                    style={{ color: '#2B2BFF' }}
                    fill="#2B2BFF"
                  />
                </div>
                <h3 
                  className="text-xl font-bold mb-3"
                  style={{ color: '#1A1A1A' }}
                >
                  {area.title}
                </h3>
                <p 
                  className="text-base leading-relaxed mb-4 flex-grow"
                  style={{ color: '#555555' }}
                >
                  {area.description}
                </p>
                <div className="flex justify-end">
                  <ArrowRight 
                    className="h-6 w-6 transition-all group-hover:translate-x-1" 
                    style={{ color: '#2B2BFF' }}
                  />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PracticeAreas;